module.exports = __webpack_public_path__ + "img/my-bkk.85b758d5.png";